import BotStore from '@src/store';
import CommonStore from '@src/stores/CommonStore';

export const listenToStores = [BotStore, CommonStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    domain: CommonStore.getMetaTags().domain,
    location: BotStore.getLocation(),
    stepPriorities: BotStore.getStepPriorities(),
  };
}

export {
  getStepPriorities,
  updateStepPriorities,
  getUpdates,
  sendUpdatedStepPriorities,
} from '@src/actions/BotActions';
